<template>
    <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @close-modal="closeModal"
        modal-alignment="top" modal-size="extra-large">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <div class="row">
                <div class="col-12">
                    <legend class="col-12 col-form-label text-primary pt-0 my-3">
                        <h5>Histórico de documentos abiertos en la plataforma</h5>
                    </legend>
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th scope="col" class="align-middle">Usuario</th>
                                <th scope="col" class="align-middle text-center" style="width: 25%">
                                    Fecha
                                </th>
                                <th scope="col" class="align-middle text-center" style="width: 25%">
                                    IP
                                </th>
                                <th scope="col" class="align-middle text-center" style="width: 15%">
                                    Expediente
                                </th>
                                <th scope="col" class="align-middle text-center" style="width: 15%">
                                    Documento
                                </th>
                                <th scope="col" class="align-middle text-center" style="width: 10%">
                                    Ver</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(v, key) in eval.data" :key="key">
                                <td class="align-middle">
                                    {{
                                            v.user
                                                ? `${v.user.first_name} ${v.user.last_name}`
                                                : ""
                                    }}
                                </td>
                                <td class="align-middle text-center">
                                    {{
                                            v.date_open
                                                ? `${v.date_open} `
                                                : ""
                                    }}
                                </td>
                                <td class="align-middle text-center">
                                    {{
                                            v.ip_adress
                                                ? `${v.ip_adress} `
                                                : ""
                                    }}
                                </td> 
                                <td class="align-middle text-center">
                                    {{
                                            v.eval_test
                                                ? `${v.eval_test.accreditation_applications.record} `
                                                : ""
                                    }}
                                </td>
                                <td class="align-middle text-center">
                                    {{
                                            v.path
                                                ? `${v.path.split("/")[v.path.split("/").length - 1]} `
                                                : ""
                                    }}
                                </td>
                                <td class="align-middle text-center">
                                    <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                                        {{ $t("Visualizar") }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </template>
    </app-modal>
</template>
  
<script>
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
    mixins: [ModalMixin],
    props: {
        evalTestId: Number,
    },
    data() {
        return {
            preloader: false,
            modalId: "audit-eval-test-modal",
            modalTitle: "",
            info: {},
            accApp: {},
            eval: {}
        };
    },
    created() {
        this.getData();
    },
    filters: {
        dateFormat: function (value) {
            return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
        },
    },
    methods: {
        getData() {
            this.preloader = true;
            let url = `/accreditations/applications/show-audit/${localStorage.getItem('audit_item')}`;
            axiosGet(url)
                .then((response) => {
                    if (response.status == 200) {
                        this.accApp = response.data.accApp;
                        this.eval = response.data.eval;
                    }
                })
                .catch(({ error }) => {
                    console.log(error);
                })
                .finally(() => {
                    this.preloader = false;
                });
        },
        openTab(path) {
            var info = {};
            info['accAppId'] = null;
            info['evalTestId'] = this.evalTestId;
            info['path'] = String(path);
            this.$store.dispatch("registerFileLog", info);
            window.open(path, "_blank").focus();
        },
    },
};
</script>
<style>
.title-legend {
    font-size: 1em;
}
</style>
  